import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { format } from "date-fns";
import Logo from "user/components/common/Logo";
import { useGetCustomer } from "common/hooks/user/account/useGetCustomer";
import OrderItem from "../order/-components/OrderItem";
import { useAuthStore } from "user/store/useAuthStore";
import { useGetOrder } from "common/hooks/user/order/useGetOrder";
import { enum_api_uri } from "common/hooks/utils/enum";
import { formatDeliveryTime, formatDeliveryTimeFromDate } from "common/hooks/utils/utils";
import loginBG from "../../assets/images/loginBG.png";
import banner from "../../assets/icons/main_order_banner.svg";
import { ReactComponent as MyPage } from "../../assets/icons/mypage.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/rightArrow.svg";
import "swiper/css";

export default function Main() {
    const navigate = useNavigate();
    const onClickLogout = useAuthStore(state => state.clearAuth);

    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startDate = format(new Date(firstDay), "yyyy-MM-dd");
    const endDate = format(new Date(lastDay), "yyyy-MM-dd");

    const { data: customerData } = useGetCustomer();
    const { data: listData, refetch: listRefetch } = useGetOrder(1, "", "", startDate, endDate);
    // console.log("listData", listData);

    return (
        <div
            className="min-h-[100dvh] bg-cover bg-center"
            style={{
                backgroundImage: `url(${loginBG})`,
            }}
        >
            <div className="wrapper flex justify-between items-center py-[14px]">
                <Logo className="[&_a]:!max-w-[100px] [&_a]:h-auto [&_a]:!bg-contain" />
                <Link to="/mypage">
                    <MyPage />
                </Link>
            </div>
            <div className="wrapper py-[28px]">
                <div>
                    <p className="text-[18px] leading-[28px] mb-[8px] break-keep">{customerData?.data.customer_name}</p>
                    <p className="text-[#273219] text-[26px] leaindg-[40px] font-bold">{customerData?.data.m_name} 님</p>
                </div>

                <Link
                    to="/new-order"
                    className="relative p-[20px_20px_56px] inline-block w-full mt-[44px] mb-[16px] text-white rounded-[20px] overflow-hidden shadow-[0px_0px_16px_0px_#00000033] aspect-[1/0.25] min-h-[140px]"
                    style={{ background: "linear-gradient(95.87deg, #273219 0%, #4B632B 97.56%)" }}
                >
                    <span
                        className="absolute inset-0 bg-right bg-no-repeat mobile450:translate-x-[20%] mobile450:bg-contain transition-bg duration-[0.3s]"
                        style={{ backgroundImage: `url(${banner})` }}
                    ></span>
                    <div className="relative">
                        <p className="font-bold text-[24px] leading-[36px] mb-[4px]">신규주문</p>
                        <p className="leading-[24px] text-[#dddddd]">정성을 담아 전달해 드립니다.</p>
                    </div>
                </Link>

                <div className="rounded-[19px] overflow-hidden bg-white shadow-[0px_0px_16px_0px_#D1D1D6CC]">
                    <div className="bg-[#F3F3F8] py-[12px] px-[16px] flex justify-between">
                        <p className="font-bold text-[18px] leading-[28px]">주문내역</p>
                        <Link to="/orders" className="text-[#484964] text-[14px] leading-[20px] flex items-center gap-[17px]">
                            <p>
                                이번 달 접수
                                <span className="text-[#4B632B] font-bold mx-[5px]">{listData?.total_count}</span>건
                            </p>
                            <ArrowRight className="[&_path]:stroke-[#484964]" />
                        </Link>
                    </div>

                    {listData && listData.data_list?.length > 0 ? (
                        <Swiper
                            slidesPerView={1}
                            pagination
                            modules={[Pagination]}
                            className="[&_.swiper-pagination]:pt-[12px] [&_.swiper-pagination]:pb-[20px] [&_.swiper-pagination]:flex [&_.swiper-pagination]:justify-center [&_.swiper-pagination]:items-center [&_.swiper-pagination]:gap-[8px] [&_.swiper-pagination-bullet]:w-[8px] [&_.swiper-pagination-bullet]:h-[8px] [&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:transition-all [&_.swiper-pagination-bullet]:duration-[0.3s] [&_.swiper-pagination-bullet]:bg-[#DADEE4] [&_.swiper-pagination-bullet-active]:!w-[40px] [&_.swiper-pagination-bullet-active]:!bg-[#484964] [&_.swiper-pagination-bullet-active]:rounded-[20px]"
                        >
                            {listData?.data_list.map(data => {
                                const imgSrc = data.product_info.product_image?.file_name;
                                const date = data.recipient_info.delivery_date;
                                const orderDateFull = data.order_date_full; // 즉시 배송일때 설정된 시간
                                const deliveryTime = orderDateFull ?? "";
                                const specificTime = data.recipient_info.delivery_time
                                    ? formatDeliveryTime(data.recipient_info.delivery_time)
                                    : ""; // 즉시 배송이 아닐 때 설정한 시간
                                const time = data.delivery_immediate
                                    ? "즉시배송" + " " + `(${formatDeliveryTimeFromDate(deliveryTime)})`
                                    : specificTime;

                                return (
                                    <SwiperSlide
                                        key={data.order_idx}
                                        className="cursor-pointer"
                                        onClick={() => navigate(`/orders/${data.order_idx}`)}
                                    >
                                        <OrderItem
                                            orderDate={data.order_date}
                                            status={data.status_info.order_status_text}
                                            productImg={imgSrc ? enum_api_uri.api_uri + "/" + imgSrc : null}
                                            productCategory={data.product_info.product_category}
                                            productName={data.product_info.product_name}
                                            deliveryDate={date + " " + time}
                                            deliveryAddress={
                                                data.recipient_info.delivery_address +
                                                " " +
                                                (data.recipient_info.delivery_address_detail ?? "")
                                            }
                                            recipientName={data.recipient_info.recipient_name}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    ) : (
                        <div className="py-[65px] text-[#A3AED0] text-[18px] font-[500] leading-[28px] text-center">
                            주문 내역이 없습니다.
                        </div>
                    )}

                    <div className="bg-[#F3F3F8] py-[12px] px-[16px] flex justify-center items-center">
                        <a href="tel:027047880" className="font-bold leading-[24px] text-[#4B632B]">
                            02-704-7880
                        </a>
                        <span className="w-[1px] h-[12px] bg-[#4B632B] mx-[12px]"></span>
                        <a href="tel:01077117880" className="font-bold leading-[24px] text-[#4B632B]">
                            010-7711-7880
                        </a>
                    </div>
                </div>

                <div className="flex flex-col gap-[12px] items-center mt-[24px]">
                    <button type="button" className="underline text-[#999999] text-[14px] leading-[20px]" onClick={onClickLogout}>
                        로그아웃
                    </button>
                    <p className="text-gray3 text-sm">Copyright &copy; 2025. (주)고려원예</p>
                </div>
            </div>
        </div>
    );
}
